import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[dynamicComponent]'
})
export class DynamicComponentDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}